export const zh_TW = {
  "appName": {
    "message": "PttChrome",
    "description": "The title of the application, displayed in the web store."
  },
  "appDesc": {
    "message": "專為 BBS 瀏覽設計，採 GNU/GPL 授權的 telnet 連線程式套件",
    "description":"The description of the application, displayed in the web store."
  },

  // side menus
  "menu_coloredCopy": {
    "message": "複製 (包含 ANSI 顏色)"
  },
  "menu_goToOtherSite": {
    "message": "其他站台"
  },
  "menu_paste": {
    "message": "貼上"
  },
  "menu_selectAll": {
    "message": "全選"
  },
  "menu_mouseBrowsing": {
    "message": "滑鼠瀏覽"
  },
  "menu_settings": {
    "message": "設定"
  },

  // context menus
  "cmenu_copy": {
    "message": "複製"
  },
  "cmenu_copyAnsi": {
    "message": "複製 (包含 ANSI 顏色)"
  },
  "cmenu_paste": {
    "message": "貼上"
  },
  "cmenu_selectAll": {
    "message": "全選"
  },
  "cmenu_searchGoogle": {
    "message": "在 Google 上搜尋"
  },
  "cmenu_quickSearch": {
    "message": "快速搜尋"
  },
  "cmenu_openUrlNewTab": {
    "message": "在新分頁中開啟連結"
  },
  "cmenu_copyLinkUrl": {
    "message": "複製連結網址"
  },
  "cmenu_mouseBrowsing": {
    "message": "滑鼠瀏覽"
  },
  "cmenu_showInputHelper": {
    "message": "輸入小幫手 ..."
  },
  "cmenu_showLiveArticleHelper": {
    "message": "Live 文小幫手 ..."
  },
  "cmenu_settings": {
    "message": "設定"
  },
  "cmenu_restartInTab": {
    "message": "在新分頁重新開啟 PttChrome"
  },

  // options nav
  "options_general": {
    "message": "一般"
  },
  "options_about": {
    "message": "關於"
  },

  // options
  "options_enablePicPreview": {
    "message": "當滑鼠在圖片連結上時顯示圖片預覽"
  },
  "options_enableNotifications": {
    "message": "啟用水球通知"
  },
  "options_enableEasyReading": {
    "message": "啟用文章好讀模式 (實驗性)"
  },
  "options_endTurnsOnLiveUpdate": {
    "message": "END 啟用推文即時更新 (如 Alt + r)"
  },
  "options_copyOnSelect": {
    "message": "選取文字時自動複製文字"
  },
  "options_preferences": {
    "message": "設定"
  },
  "options_antiIdleTime": {
    "message": "防閒置間隔 (秒)"
  },
  "options_lineWrap": {
    "message": "自動換行, 當貼上的字長於"
  },
  "options_reset": {
    "message": "設回預設值"
  },
  "options_appearance": {
    "message": "介面"
  },
  "options_bbsMargin": {
    "message": "BBS 周圍邊距 (像素)"
  },
  "options_fontSize": {
    "message": "BBS 字體大小"
  },
  "options_termSize": {
    "message": "BBS 終端機大小"
  },
  "options_cols": {
    "message": "寬"
  },
  "options_rows": {
    "message": "高"
  },
  "options_fontSize": {
    "message": "字體大小 (px)"
  },
  "options_fontSizeMax": {
    "message": "最大字體大小 (px)"
  },
  "options_fixedTermSize": {
    "message": "固定終端機大小"
  },
  "options_fixedFontSize": {
    "message": "固定字體大小"
  },
  "options_maxFontSize": {
    "message": "限制最大字體大小"
  },
  "options_fontFitWindowWidth": {
    "message": "把字體拉大來補滿畫面"
  },
  "options_fontFace": {
    "message": "字型"
  },
  "options_mouseBrowsing": {
    "message": "滑鼠瀏覽"
  },
  "options_useMouseBrowsing": {
    "message": "預設使用滑鼠瀏覽"
  },
  "options_mouseBrowsingHighlight": {
    "message": "啟用滑鼠瀏覽的底色效果"
  },
  "options_highlightColor": {
    "message": "底色"
  },
  "options_mouseLeftFunction": {
    "message": "滑鼠左鍵"
  },
  "options_mouseMiddleFunction": {
    "message": "滑鼠中鍵"
  },
  "options_mouseWheelFunction1": {
    "message": "滑鼠滾輪"
  },
  "options_mouseWheelFunction2": {
    "message": "滑鼠右鍵 + 滑鼠滾輪"
  },
  "options_mouseWheelFunction3": {
    "message": "滑鼠左鍵 + 滑鼠滾輪"
  },
  "options_none": {
    "message": "無動作"
  },
  "options_doPaste": {
    "message": "執行 '貼上'"
  },
  "options_leftKey": {
    "message": "送出左方向鍵"
  },
  "options_rightKey": {
    "message": "送出右方向鍵"
  },
  "options_enterKey": {
    "message": "送出ENTER鍵"
  },
  "options_upDown": {
    "message": "控制上 / 下"
  },
  "options_pageUpDown": {
    "message": "控制上頁 / 下頁"
  },
  "options_threadLastNext": {
    "message": "控制文章前篇 / 下篇"
  },

  // about page
  "about_appName_subtitle": {
    "message": "開放原始碼的 BBS 瀏覽軟體",
  },
  "about_description": {
    "message": "原作者為 #link_github_iamchucky#。此版本是由 #link_github_robertabcd# 修改，使用 Websocket 加密連線，並支援大多數瀏覽器。本分支由 #link_github_current_owner# 維護。",
  },
  "about_version_title": {
    "message": "版本"
  },
  "about_version_content": {
    "message": [
      "此版本：#link_current_PttChrome#, #link_GPL20#.",
      "上游版本：#link_robertabcd_PttChrome#, #link_GPL20#.",
      "原版本：webapp12 6/2/2015, #link_iamchucky_PttChrome#, #link_GPL20#."
    ]
  },
  "about_new_title": {
    "message": "新功能"
  },
  "about_new_content": {
    "message": [
      '加入 Websocket 連線',
      '部分使用 React 重構'
    ]
  },

  // alerts
  "alert_developerModeHeader": {
    "message": "開發者模式"
  },
  "alert_developerModeText": {
    "message": "您正在使用開發者模式。此版本的 PttChrome 並不穩定，無法保證所有功能會正常運作。"
  },
  "alert_developerModeDismiss": {
    "message": "是，我瞭解了"
  },

  "alert_connectionHeader": {
    "message": "你斷線了!"
  },
  "alert_connectionText": {
    "message": "現在要重新連線嗎?"
  },
  "alert_connectionReconnect": {
    "message": "重新連線 (ENTER)"
  },

  "alert_pasteShortcutHeader": {
    "message": "貼上"
  },
  "alert_pasteShortcutText": {
    "message": "請使用 Shift+Insert 快速鍵來貼上。"
  },
  "alert_pasteShortcutClose": {
    "message": "確定"
  },

  // notifications
  "notification_said": {
    "message": "說:"
  },

  // input helper
  "inputHelperTitle": {
    "message": "輸入小幫手"
  },
  "colorTitle": {
    "message": "上色"
  },
  "colorHelperSend": {
    "message": "送出 ANSI 顏色字元"
  },
  "colorHelperSendMenuFore": {
    "message": "只送出前景色彩"
  },
  "colorHelperSendMenuBack": {
    "message": "只送出背景色彩"
  },
  "colorHelperSendMenuReset": {
    "message": "送出色彩還原碼"
  },
  "colorHelperBlink": {
    "message": "閃爍"
  },
  "colorHelperPreview": {
    "message": "▅ 預 覽 ▅"
  },
  "colorHelperTooltip1": {
    "message": '點滑鼠"左"鍵選"前景"顏色'
  },
  "colorHelperTooltip2": {
    "message": '點滑鼠"右"鍵選"背景"顏色 (上排)'
  },

  // symbols
  "symTitle": {
    "message": "符號"
  },
  "symTitle_general": {
    "message": "一般"
  },
  "symTitle_lineBorders": {
    "message": "線條邊框"
  },
  "symTitle_blocks": {
    "message": "方塊"
  },
  "symTitle_lines": {
    "message": "線條"
  },
  "symTitle_special": {
    "message": "特殊"
  },
  "symTitle_brackets": {
    "message": "括弧"
  },
  "symTitle_greek": {
    "message": "希臘"
  },
  "symTitle_phonetic": {
    "message": "注音"
  },
  "symTitle_math": {
    "message": "數學"
  },
  "symTitle_hiragana": {
    "message": "平假名"
  },
  "symTitle_katakana": {
    "message": "片假名"
  },

  // emoticons
  "emoTitle": {
    "message": "表情"
  },
  "emoTitle_angry": {
    "message": "生氣"
  },
  "emoTitle_meh": {
    "message": "酸民"
  },
  "emoTitle_sweat": {
    "message": "汗顏加三條線"
  },
  "emoTitle_happy": {
    "message": "開心"
  },
  "emoTitle_other": {
    "message": "其他"
  },

  // live helper
  "liveHelperEnable": {
    "message": "啟用"
  },
  "liveHelperSpan": {
    "message": "推文每"
  },
  "liveHelperSpanSec": {
    "message": "秒自動更新"
  },

  // tooltips
  "tooltip_antiIdleTime": {
    "message": "輸入 0 可停用這功能。"
  },
  "tooltip_fontFace": {
    "message": "以逗號隔開，由欲套用的字型開始至較通用的字型。"
  }

};
